import { render, staticRenderFns } from "./TemplatesDocs.vue?vue&type=template&id=82bd9844&scoped=true"
import script from "./TemplatesDocs.vue?vue&type=script&lang=js"
export * from "./TemplatesDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bd9844",
  null
  
)

export default component.exports